import { render, staticRenderFns } from "./jqs_zhuanlan.vue?vue&type=template&id=7e0b618c&scoped=true"
import script from "./jqs_zhuanlan.vue?vue&type=script&lang=js"
export * from "./jqs_zhuanlan.vue?vue&type=script&lang=js"
import style0 from "./jqs_zhuanlan.vue?vue&type=style&index=0&id=7e0b618c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7e0b618c",
  null
  
)

export default component.exports